import React from 'react'

const SpecificCourseCard = ({ head, desc }) => {
    return (
        <div className='specific-course-card'>
            <div>
                <h4 style={{ color: "#4D0085" }}>{head}</h4>
                <p style={{ marginTop: "40px" }}>{desc}</p>
            </div>
        </div>
    )
}

export default SpecificCourseCard
